import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { translate } from "react-i18next";
// import Slider from "react-slick";
import Layout from "../../components/Layout";
// import NewsletterWidget from "../containers/NewsletterWidget";
import ScrollAnimation from "react-animate-on-scroll";
import VCCustomGPWChart from "./VCCustomGPWChart";
// import A from "../../components/A";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullWidthStyle: null,
      bannersMarginStyle: null,
      bannersPaddingStyle: null,
    };
    this.containerNode = React.createRef();
  }

  handleResize = () => {
    const { clientWidth } = this.containerNode.current;
    const space = (window.innerWidth - clientWidth) / 2;
    const fullWidthStyle = {
      marginLeft: "-" + space + "px",
      paddingLeft: space + "px",
      marginRight: "-" + space + "px",
      paddingRight: space + "px",
    };
    const bannersMarginStyle = {
      marginLeft: "-" + space + "px",
      marginRight: "-" + space + "px",
    };
    const bannersPaddingStyle = {
      paddingLeft: space + "px",
      paddingRight: space + "px",
    };
    this.setState({ fullWidthStyle, bannersMarginStyle, bannersPaddingStyle });
  };

  componentDidMount() {
    this.props.pageView();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    // clean up listeners
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <Layout
        homeWrapper={true}
        containerNode={this.containerNode}
        title={this.props.t("custom:home.title")}
        subtitle={this.props.t("custom:home.subtitle")}
      >
        <Helmet>
          <title>{this.props.t("custom:home.pageTitle")}</title>
        </Helmet>
        <div
          className="section-support full-width"
          style={this.state.fullWidthStyle}
        >
          <div className="row">
            <ScrollAnimation animateOnce animateIn="fadeInLeft">
              <div className="col-md-6">
                <h1>{this.props.t("custom:home.seoH1")}</h1>
                <h2>
                  {this.props.t("custom:home.supportH1")} <br />
                  {this.props.t("custom:home.supportH2")}
                </h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: this.props.t("custom:home.supportP"),
                  }}
                />
              </div>
            </ScrollAnimation>
          </div>
        </div>
        <div
          className="section-advantages full-width"
          style={this.state.fullWidthStyle}
        >
          <div className="row">
            <div className="col-lg-6">
              <ScrollAnimation animateIn="fadeInLeft" animateOnce>
                <div className="advantage">
                  <div className="advantage__content">
                    <h3>{this.props.t("custom:home.advantage1H")}</h3>
                    <p>{this.props.t("custom:home.advantage1P")}</p>
                  </div>

                  <img src="/img/icon1.svg" alt="icon" />
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-lg-6">
              <ScrollAnimation animateOnce animateIn="fadeInRight" delay={0.4}>
                <div className="advantage">
                  <img src="/img/icon2.svg" alt="icon" />

                  <div className="advantage__content">
                    <h3>{this.props.t("custom:home.advantage2H")}</h3>
                    <p>{this.props.t("custom:home.advantage2P")}</p>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-lg-6">
              <ScrollAnimation animateOnce animateIn="fadeInLeft" delay={0.6}>
                <div className="advantage">
                  <div className="advantage__content">
                    <h3>
                      {this.props.t("custom:home.advantage3H1")}
                      <br />
                      {this.props.t("custom:home.advantage3H2")}
                    </h3>
                    <p>{this.props.t("custom:home.advantage3P")}</p>
                  </div>
                  <img src="/img/icon3.svg" alt="icon" />
                </div>
              </ScrollAnimation>
            </div>

            <div className="col-lg-6">
              <ScrollAnimation animateOnce animateIn="fadeInRight" delay={0.8}>
                <div className="advantage">
                  <img src="/img/icon4.svg" alt="icon" />
                  <div className="advantage__content">
                    <h3>{this.props.t("custom:home.advantage4H")}</h3>
                    <p>{this.props.t("custom:home.advantage4P")}</p>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {/* <ScrollAnimation animateIn="fadeInUp" animateOnce> */}
              {/* <A
                  href={this.props.t("custom:home.advantageAHref")}
                  className="arrow-link"
                >
                  {this.props.t("custom:home.advantageATitle")}
                </A>
              </ScrollAnimation> */}
            </div>
          </div>
        </div>
        {/* <VCCustomGPWChart/> */}
        {/* <ScrollAnimation animateIn="fadeIn" animateOnce>
          <div
            className="section-banner woman-bg"
            style={this.state.bannersMarginStyle}
          >
            <Slider
              {...{
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                cssEase: "linear",
                autoplay: true,
                autoplaySpeed: 3000
              }}
            >
              <div className="section-banner__item">
                <div style={this.state.bannersPaddingStyle}>
                  <img src="img/baner1.jpg" alt="foto" />
                  <div className="row">
                    <div className="col-md-6">
                      <h3>{this.props.t("custom:home.womanH")}</h3>
                      <p>{this.props.t("custom:home.womanP")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-banner__item">
                <div style={this.state.bannersPaddingStyle}>
                  <img src="img/baner2.jpg" alt="foto" />
                  <div className="row">
                    <div className="col-md-6">
                      <h3>{this.props.t("custom:home.womanH")}</h3>
                      <p>{this.props.t("custom:home.womanP")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-banner__item">
                <div style={this.state.bannersPaddingStyle}>
                  <img src="img/baner3.jpg" alt="foto" />
                  <div className="row">
                    <div className="col-md-6">
                      <h3>{this.props.t("custom:home.womanH")}</h3>
                      <p>{this.props.t("custom:home.womanP")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </ScrollAnimation> */}

        {/* <div className="section-quick-links">
          <div className="quick-links">
            <ScrollAnimation animateOnce animateIn="fadeInUp">
              <div className="quick-links__item">
                <img src="/img/icon-elastycze-formy.svg" alt="icon" />
                <h3>
                  <A href={this.props.t("custom:home.links1Href")}>
                    {this.props.t("custom:home.links1Title")}
                  </A>
                </h3>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" delay={0.2}>
              <div className="quick-links__item">
                <img src="/img/icon-outsourcing.svg" alt="icon" />
                <h3>
                  <A href={this.props.t("custom:home.links2Href")}>
                    {this.props.t("custom:home.links2Title")}
                  </A>
                </h3>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" delay={ 0.4 }>
              <div className="quick-links__item">
                <img src="/img/icon-dobor-personalny.svg" alt="icon" />
                <h3>
                  <A href={this.props.t("custom:home.links3Href")}>
                    {this.props.t("custom:home.links3Title")}
                  </A>
                </h3>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" delay={ 0.4 }>
              <div className="quick-links__item">
                <img src="/img/icon-transgraniczna-wymiana.svg" alt="icon" />
                <h3>
                  <A href={this.props.t("custom:home.links4Href")}>
                    {this.props.t("custom:home.links4Title")}
                  </A>
                </h3>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" delay={ 0.4 }>
              <div className="quick-links__item">
                <img src="/img/icon-doradztwo-hr.svg" alt="icon" />
                <h3>
                  <A href={this.props.t("custom:home.links5Href")}>
                    {this.props.t("custom:home.links5Title")}
                  </A>
                </h3>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" delay={ 0.4 }>
              <div className="quick-links__item">
                <img src="/img/icon-payroll.svg" alt="icon" />
                <h3>
                  <A href={this.props.t("custom:home.links6Href")}>
                    {this.props.t("custom:home.links6Title")}
                  </A>
                </h3>
              </div>
            </ScrollAnimation>
          </div>
        </div> */}

        {/* <div
          className="section-with-chart full-width"
          style={this.state.fullWidthStyle}
        >
          <div className="row">
            <div className="col-lg-6">
              <ScrollAnimation animateIn="fadeIn" animateOnce>
                <h3>{this.props.t("custom:home.researchH1")}</h3>
                <p>
                  {this.props.t("custom:home.researchP1")}
                  <br />
                  {this.props.t("custom:home.researchP2")}
                </p>
              </ScrollAnimation>
            </div>
            <div className="col-lg-6 align-items-end d-flex">
            <ScrollAnimation animateIn="fadeIn" animateOnce>
              <NewsletterWidget />
            </ScrollAnimation>
            </div>
          </div>
        </div> */}

        {/* <div className="section-with-slider">
          <Slider
            {...{
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 4,
              className: "slider",
              autoplay: true,
              autoplaySpeed: 3000,
              responsive: [
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
            }}
          >
            <div className="slider__item">
              <img src="/img/carousel/amica.png" alt="foto" />
            </div>
            <div className="slider__item">
              <img src="/img/carousel/carlsberg.png" alt="foto" />
            </div>
            <div className="slider__item">
              <img src="/img/carousel/pfleiderer.png" alt="foto" />
            </div>
            <div className="slider__item">
              <img src="/img/carousel/rabwn.png" alt="foto" />
            </div>
            <div className="slider__item">
              <img src="/img/carousel/samsung.png" alt="foto" />
            </div>
            <div className="slider__item">
              <img src="/img/carousel/vw.png" alt="foto" />
            </div>
          </Slider>
        </div> */}
      </Layout>
    );
  }
}

export default translate()(Home);



// WEBPACK FOOTER //
// ./src/custom/components/Home.js